import 'font-awesome/css/font-awesome.min.css';

import React, { Component } from 'react';
// import axios from 'axios'

import { connect } from 'react-redux';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import SingleChoice from "./ComponentV9/SingleChoice";
import MultipleChoice from "./ComponentV9/MultipleChoice";
import TextBox from "./ComponentV9/TextBox";
import MultiLineText from "./ComponentV9/MultiLineText";
import RatingScale from "./ComponentV9/RatingScale";
import NPS from "./ComponentV9/NPS";
import NPSV2 from "./ComponentV9/NPSV2";
import Email from "./ComponentV9/Email";
import Number from "./ComponentV9/Number";
import Dropdown from "./ComponentV9/Dropdown";
import YesNo from "./ComponentV9/YesNo";
import Date from "./ComponentV9/Date";
import Location from "./ComponentV9/Location";

import { questionsActions } from '../../../_actions';

import QuestionHeader from '../Component/QuestionHeader';

import LogoHeaderV9 from './LogoHeaderV9';

class QuestionPublish extends Component {
  constructor(props) {
    super(props);
    this.state = {

      SurveyCode:this.props.codeValue,

      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 0,
      submitSucces:false,

      surveyLanguageName:'English',
      surveyLanguageCode:'',
      ShowSubmitButton:false,


      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn:false,
      afterSubmitData:{
        "thankyouText":'',
        "bgColor":'',
        "bgImage":"",
        "textColor":"",
        "logo":""
      },
      alreadySubmitted:false,
      clicked:false,

      showDropdownQues:false,
      dropdownInput:"",
      IpObj:{},
      storeStateCode:"",
      storeCityCode:"",
      submitBlock:false
    }
  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());

    // const getData = async () => {
    //   const res = await axios.get('https://geolocation-db.com/json/')
    //   this.setState({IpObj:res.data})
    //   return(res.data)
    // }
    // getData();


    this.props.dispatch(questionsActions.getQuestionList({ code: this.state.SurveyCode }, 'v4'));

    this.props.dispatch(questionsActions.getSurveyDesignByCode({ code: this.state.SurveyCode }));

    // this.props.dispatch(questionsActions.getLanguageLabel());

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted:true
      }
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false

      }
    } else {
      return {
        ...nextProps
      }
    }

  }


  prevQues = () => {
    this.setState({ changeType: "fade1" })
    this.setState({ShowSubmitButton:false});

    let { questions } = this.props;
    let { questionsList } = questions;


    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length>0) {
      function GetIndex (CurrQuesIndex){
        let indx=questionsList.findIndex(prev=>prev.id===CurrQuesIndex);
        if(indx!==-1){
          return indx
        }
        else{
          return -1
        }
      }

      if (GetIndex(CurrQuesIndex) > 0 && GetIndex(CurrQuesIndex) < questionsList.length) {
        if(this.ValidateNextPrevLogic(questionsList[GetIndex(CurrQuesIndex)-2])){
          CurrQuesIndex = questionsList[GetIndex(CurrQuesIndex)-1].id;
        }
        else{
          CurrQuesIndex = questionsList[GetIndex(CurrQuesIndex)-2].id;
        }


        this.setState({ CurrQuesIndex },()=>{
          // this.handleSubmitAppear();
        });
      }
      else if(GetIndex(CurrQuesIndex)===(questionsList.length-1)){
        // CurrQuesIndex = CurrQuesIndex - 1;
        CurrQuesIndex = questionsList[GetIndex(CurrQuesIndex)-1].id;

        this.setState({ CurrQuesIndex },()=>{
          // this.handleSubmitAppear();
        });
      }
    }


  }

  nextQues = () => {
    this.setState({ changeType: "fade", clicked:'' })

    let { questions } = this.props;
    let { questionsList, answersList } = questions;

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length>0) {
      

      function GetIndex (CurrQuesIndex){
        let indx=questionsList.findIndex(prev=>prev.id===CurrQuesIndex);
        if(indx!==-1){
          return indx
        }
        else{
          return -1
        }
      }


      if (GetIndex(CurrQuesIndex) >= 0 && GetIndex(CurrQuesIndex) < (questionsList.length-1)) {

        if(this.ValidateNextPrevLogic(questionsList[GetIndex(CurrQuesIndex)])){
          CurrQuesIndex = questionsList[GetIndex(CurrQuesIndex)+1].id;
        }
        else{
          CurrQuesIndex = questionsList[GetIndex(CurrQuesIndex)+2].id;
        }


        this.setState({ CurrQuesIndex },()=>{
          this.handleSubmitAppear();
        });

      }

    }

    let flag = 0
    let unattemptList = [];
    answersList.forEach((item, index) => {
      if (item.isMandatory) {


          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(item.questionId)
          }
      

      }
    })

    if(flag){
      this.setState({ unattemptList: unattemptList });

      if(this.state.mandatoryOn &&  questionsList && questionsList.length>0){


        if(this.state.unattemptList && this.state.unattemptList.length>0){
          this.setState({ CurrQuesIndex: unattemptList[0] },()=>{
            this.handleSubmitAppear();
          });

        }
  
      }

    }
    else{
      this.setState({ unattemptList: [] });

      if(this.state.mandatoryOn &&  questionsList && questionsList.length>0){
          this.setState({ CurrQuesIndex: questionsList[questionsList.length-1].id },()=>{
            this.handleSubmitAppear();
          });
      }
    }


    

  }


  handleSubmitAppear =()=>{
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;

    function GetIndex (CurrQuesIndex){
      let indx=questionsList.findIndex(prev=>prev.id===CurrQuesIndex);
      if(indx!==-1){
        return indx
      }
      else{
        return -1
      }
    }


    setTimeout(()=>{
      if(questionsList && questionsList.length > 0 && ((questionsList.length-1) === GetIndex(CurrQuesIndex))){
        this.setState({ShowSubmitButton:true});
      }
      else{
        this.setState({ShowSubmitButton:false});
      }
    },300)


  }

  handleRadio = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;


    if(ques.templateId===15){

          this.setState({ radioButton: currentOption.id })
          this.props.dispatch(questionsActions.handleSubmitPreChange(ques, answersList, questionsList, currentOption, currentOption.weightage, surveyScreenData));
      

          let type = (ques && ques.transl && ques.transl["customLocation"] && ques.transl["customLocation"]["type"])? ques.transl["customLocation"]["type"]:"";
          if(type==="state"){
            this.setState({storeStateCode:currentOption.isoCode});
          }
          
    }else if(ques.templateId===5){

            this.props.dispatch(questionsActions.handleSubmitPreChange(ques, answersList, questionsList, currentOption, currentOption.weightage, surveyScreenData,currentOption.name));

    }
    else{


          if (this.state.radioButton === currentOption.id) {
            this.setState({ radioButton: null });
            this.props.dispatch(questionsActions.handleSubmitPreChange(ques, answersList, questionsList, "", 0, surveyScreenData));
          }
          else {
            this.setState({ radioButton: currentOption.id })
            this.props.dispatch(questionsActions.handleSubmitPreChange(ques, answersList, questionsList, currentOption, currentOption.weightage, surveyScreenData));
          }
          
  
    }







    // if(!ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    setTimeout(()=>this.nextQues(), 300);






  }





  
  handleCheckInput = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;

    if(true) {

      this.setState({ radioButton: currentOption.id })
      // console.log("currentOption::", currentOption)
      this.props.dispatch(questionsActions.handleSubmitPreChange(ques, answersList, questionsList, currentOption, 
        currentOption.weightage, surveyScreenData));
    }

    // setTimeout(()=>this.nextQues(), 300);

  }

  goToInstructionPage = () => {
    let { questions } = this.props;
    let { surveyScreenData, questionsList } = questions;
    
    if(surveyScreenData.isInstruction){
      this.setState({ showWelcomeScreen: false, showQuestionScreen: false, showThankyouScreen: false, instructionPage: true });
    }
    else{

      if(questionsList && questionsList.length>0){
        this.setState({CurrQuesIndex: questionsList[0].id},()=>{
          this.setState({ 
            showWelcomeScreen: false, 
            showQuestionScreen: true, 
            showThankyouScreen: false, 
            instructionPage: false 
          });
        });
      }

    }
    window.scrollTo(0, 0)

  }

  goToQuestionPage = () => {
    let { questions } = this.props;
    let { questionsList } = questions;
    if(questionsList && questionsList.length>0){
      this.setState({CurrQuesIndex: questionsList[0].id},()=>{
        this.setState({ 
          showWelcomeScreen: false, 
          showQuestionScreen: true, 
          showThankyouScreen: false, 
          instructionPage: false 
        });
        window.scrollTo(0, 0)
      });
    }


  }


  saveAnswers(surveyScreenData) {

    this.setState({submitBlock:true});


    if(surveyScreenData){
      this.setState({
        afterSubmitData:surveyScreenData
      });
    }


    let survey = {
      code: this.state.SurveyCode,
    }
    let { questions } = this.props;
    let { answersList } = questions;


    let flag = 0;
    let unattemptList = [];
    answersList.forEach((item, index) => {
      if (item.isMandatory) {


          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(item.questionId)
          }
      

      }
    })

    if (flag) {
      this.setState({ saveMsg: "Please attempt all mandatory questions!" })
      this.setState({ showRedFlag: true });
      this.setState({ unattemptList: unattemptList });

    }
    else {
      this.setState({ saveMsg: "" })
      this.setState({ unattemptList: [], submitSucces:true });


      this.props.dispatch(questionsActions.saveAnswers(answersList, survey, this.props, this.state.IpObj));
    }


  }

  ansTextBoxClick(ques) {
    this.setState({ currQues: ques });
  }

  ansTextBoxChange1 = (e,Ques) => {
    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans:1
    }

    this.setState({ textAnswer: e.target.value })


    this.props.dispatch(questionsActions.handleSubmitPreChange(Ques, answersList, questionsList, ansData, null, surveyScreenData));
  }

  ansNPSInput = (val,Ques) => {
    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;

    let ansData = {
      _id: "",
      name: val,
      ans:1
    }

    this.setState({ textAnswer: val })


    this.props.dispatch(questionsActions.handleSubmitPreChange(Ques, answersList, questionsList, ansData, null, surveyScreenData));

    

    // if(!Ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    setTimeout(()=>this.nextQues(), 300);

  }

  ansTextBoxChange2 = (e,Ques) => {
    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans:2
    }

    this.setState({ textAnswer: e.target.value })


    this.props.dispatch(questionsActions.handleSubmitPreChange(Ques, answersList, questionsList, ansData, null, surveyScreenData));
  }

  clickOK = ()=>{
    // setTimeout(()=>this.nextQues(), 300);
    this.nextQues()
  }

  clickOKLast=(Ques)=>{


    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;

    let ansData = {
      _id: "",
      name: "",
      ans:3
    }

    this.props.dispatch(questionsActions.handleSubmitPreChange(Ques, answersList, questionsList, ansData, null, surveyScreenData));



    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length>0) {
      


      if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
        CurrQuesIndex = CurrQuesIndex + 1;

        this.setState({ CurrQuesIndex });

      }
    }

    let flag = 0
    let unattemptList = [];
    answersList.forEach((item, index) => {
      if (item.isMandatory) {

          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(item.questionId)
          }
      

      }
    });

    if(flag){
      this.setState({ unattemptList: unattemptList });

      if(this.state.mandatoryOn &&  questionsList && questionsList.length>0){


        if(this.state.unattemptList && this.state.unattemptList.length>0){
          this.setState({ CurrQuesIndex: unattemptList[0] });

        }
  
      }

    }
    else{
      this.setState({ unattemptList: [] });

      if(this.state.mandatoryOn &&  questionsList && questionsList.length>0){
          this.setState({ CurrQuesIndex: questionsList.length });
      }
    }


    //nothing




  }


  onMandatoryAttempt=(elem)=>{
    this.setState({ CurrQuesIndex:elem });
    this.setState({ mandatoryOn:true });

  }

  gotoSubmit = ()=>{
    let { questions } = this.props;
    let { questionsList } = questions;

    if(questionsList && questionsList.length>0){
      let lastQueId = questionsList[questionsList.length-1].id;
      if(lastQueId){
        this.setState({CurrQuesIndex: lastQueId})
      }
    }
  }



  
  handleLanguage=(e)=>{
    if(e.target.value === 'en'){
      this.setState({surveyLanguageCode:'', surveyLanguageName: ''});
    }
    else{
      this.setState({surveyLanguageCode:e.target.value, surveyLanguageName: ""});
    }
  }



  
  openDropdownQuestion=(check)=>{
    this.setState({showDropdownQues:check})
  }

  handleDropdownSelect=(value)=>{
    this.setState({dropdownInput:value,showDropdownQues:false});
  }



  handleMatrixRadio = (ques, subQues, currentOption, items) => {

    let { questions } = this.props;
    let { questionsList, answersList, surveyScreenData } = questions;


    let currIndex2 = answersList.findIndex(element=>element.questionId === subQues.id);


    this.props.dispatch(questionsActions.handleSubmitPreChange(ques, answersList, questionsList, currentOption, currentOption.weightage, surveyScreenData,subQues));


    // setTimeout(()=>this.nextQues(), 300);

  }


  ValidateNextPrevLogic=(question)=>{
    let { questions } = this.props;
    let AnswerListFinal = questions.answersList && questions.answersList.length>0?questions.answersList:[];
    let check = false;
    if(question && question.templateId ===1){
      if(question && question["transl"] && question["transl"]["questionLogic"] && question["transl"]["questionLogic"]["id"]  && question["transl"]["questionLogic"]["enable"]){

        let otherQueId = question["transl"]["questionLogic"]["id"];
        if(AnswerListFinal && AnswerListFinal.length>0){
            let getIndex = AnswerListFinal.findIndex(prev=>prev.questionId===otherQueId);
            let answer = getIndex!==-1?AnswerListFinal[getIndex].answer:"";  
            
            if(answer){
              if(question && question["transl"] && question["transl"]["questionLogic"] && question["transl"]["questionLogic"]["answers"] && question["transl"]["questionLogic"]["answers"].length>0){
                if(question["transl"]["questionLogic"]["answers"].some(prev=>prev===answer)){
                  check= true;
                }
                else{
                  check= false;
                }
              }
              else{
                check= true;
              }
            }        
            else{
              check= true;
            }
        }
        else{
          check= true;
        }
      }
      else{
        check= true;
      }
    }
    else{
      check= true;
    }
    return check
  }





  render() {
    let { questions, getSurveyTemplateByCodeData } = this.props;

    let { getSurveyDesignByCodeData, questionsList, answersList, surveyStatus, surveyScreenData } = questions;

    let {  submitBlock, CurrQuesIndex, afterSubmitData, clicked, showDropdownQues, IpObj, storeStateCode , storeCityCode 
    } = this.state;

    let { surveyLanguageCode } = this.props;

    const isMobile = window.innerWidth <= 700;


    // let surveyScreenData = getSurveyTemplateByCodeData;


    let bgImage = '';
    let bgColor = '';
    if (surveyScreenData && surveyScreenData.bgImage) {
      bgImage = "url(" + surveyScreenData.bgImage + ")";
    }

    if (surveyScreenData && surveyScreenData.bgColor) {
      bgColor = surveyScreenData.bgColor;

    }


    let welcomeTextDislay = ""
    let instructionTextDislay = ""


    if (surveyScreenData && surveyScreenData.welcomeText) {
      welcomeTextDislay = surveyScreenData.welcomeText;
      instructionTextDislay = surveyScreenData.instructionText
    }



    let surveytitle = '';
    let bgType = '';

    if (surveyScreenData && surveyScreenData.name) {
      surveytitle = surveyScreenData.name;
      bgType = surveyScreenData.bgType;
    }



    let LabelObj = questions.getLanguageLabelData;


    function showRadioMatrix (SubQues,option){

      let getIndex1 = answersList.findIndex(prev=>prev.questionId === SubQues.id);
      let getIndex4 = answersList[getIndex1]['multiAnswer'].findIndex(prev=>prev.optionHead === option.heading)
      let getIndex3 = answersList[getIndex1]['multiAnswer'].findIndex(prev=>prev.optionId === option.id)

      if(getIndex4!==-1){
        if(getIndex3!==-1){
          return true
        }
        else{
          return false
        }

      }
      else{
        return false
      }
      
    }





    function FormatMatriXOptionHeading(question, isOption){
        let paraObjShow = {};
        if(question && question.optionsList && question.optionsList.length>0){
          question.optionsList.forEach((item)=>{
            if(paraObjShow && paraObjShow[item.heading]){
              paraObjShow[item.heading] += 1
            }
            else{
              paraObjShow[item.heading] = 1
            }
          });
        }
    
        let headingList = []
        let tempKey = Object.keys(paraObjShow);
        if(tempKey && tempKey.length>0){
          tempKey.forEach((item)=>{
          headingList.push({
            name:item,
            span:paraObjShow[item]
          })
        });
        }

        if(isOption){
          let OptionList = []
          if(headingList && headingList.length>0){
            headingList.forEach((heading)=>{
              if(question && question.optionsList && question.optionsList.length>0){
                question.optionsList.forEach((option)=>{
                  if(heading.name === option.heading){
                    OptionList.push(option)
                  }
                });
              }
            });
          }
          return OptionList
        }
        else{
          return headingList
        }

      }





    function TranslateQuestion(surveyLanguageCode, question){
      return (surveyLanguageCode!=='')?
                              (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].name)?
                                  question.transl[surveyLanguageCode].name:question.name
                            :question.name
    }



    function TranslationOptionMatrix(question, heading, surveyLanguageCode){
      let optionId = "";
      if(question && question.optionsList && question.optionsList.length>0){
        let Index = question.optionsList.findIndex(prev=>prev.heading === heading);
        optionId = question.optionsList[Index].id;
      }
      return (surveyLanguageCode!=='')?
      (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].headingList && question.transl[surveyLanguageCode].headingList[optionId])?
          question.transl[surveyLanguageCode].headingList[optionId]:heading :heading
    }



    function SurveyAttributes(name){
      return (surveyLanguageCode!=='')?
                  (getSurveyTemplateByCodeData && getSurveyTemplateByCodeData.transl && getSurveyTemplateByCodeData.transl[surveyLanguageCode] && getSurveyTemplateByCodeData.transl[surveyLanguageCode][name])?
                  getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]:""
                :
                getSurveyTemplateByCodeData && getSurveyTemplateByCodeData[name]?getSurveyTemplateByCodeData[name]:""
    }



 
    // function NPSColor(question){

    //   function NPSName(optionID, optionName, surveyLanguageCode, question){

    //     return  (surveyLanguageCode!=='')?
    //     (question && question.transl && 
    //       question.transl[surveyLanguageCode] && 
    //         question.transl[surveyLanguageCode].optionsList && 
    //           question.transl[surveyLanguageCode].optionsList[optionID])?
    //             question.transl[surveyLanguageCode].optionsList[optionID]:optionName
    //     :optionName
    //   }


    //   let Color = "#a3a3a3";
    //   let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
    //   let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
    //   if(answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6 ){
    //     Color = "#ed3e34";
    //     if(answer === 1 || answer === 2){
    //       Name = NPSName("Extremelydissatisfied", "Extremely dissatisfied", surveyLanguageCode, question)
    //     }
    //     else if(answer === 3 || answer === 4){
    //       Name = NPSName("Dissatisfied", "Dissatisfied", surveyLanguageCode, question)
    //       console.log('Dissatisfied Name: ',Name)
    //     }
    //     else if(answer === 5 || answer === 6){
    //       Name = NPSName("Neither", "Neither", surveyLanguageCode, question)
    //     }
    //   }
    //   else if(answer === 7 || answer === 8){
    //     Color = "#fcb817";
    //     Name = NPSName("Satisfied", "Satisfied", surveyLanguageCode, question)
    //   }
    //   else if(answer === 9 || answer === 10){
    //     Color = "#0acc4b";
    //     Name = NPSName("Extremelysatisfied", "Extremely satisfied", surveyLanguageCode, question)
    //   }
    //   return {
    //     color:Color,
    //     name:Name
    //   }
    // }



    function CompletedCount () {
      let answerCount  = 0;

      //---------------------------- basic ---------------------------------------
      let answersList= [];
      let AnswerListFinal = answersList && questions.answersList && questions.answersList.length>0?questions.answersList:[];
  
      if(questionsList && questionsList.length>0){
        questionsList.forEach((ques)=>{
  
          if(ques.templateId===13){
                  let getIndex = AnswerListFinal.findIndex(prev=>prev.questionId === ques.id);
                  if(getIndex!==-1){
                    answersList.push({
                      ...AnswerListFinal[getIndex],
                      SubQuestionList:ques.SubQuestionList
                    });
                  }
          }
          else{
                  let getIndex = AnswerListFinal.findIndex(prev=>prev.questionId === ques.id);
                  if(getIndex!==-1){
                    answersList.push(AnswerListFinal[getIndex]);
                  }
          }
  
        });
      }
      //-------------------------------------------------------------------
  
      if (questionsList && questionsList.length>0) {
        
        questionsList.forEach((Ques)=>{

        if (true) {
          //----------------latestcode ---------------------------
          let questionId = Ques && Ques.id? Ques.id:"";
          let flag = 0;
          
          if(answersList && answersList.length>0){
            let getIndex2 = answersList.findIndex(prev=>prev.questionId === questionId);
            if(getIndex2!==-1){
            let item = answersList[getIndex2];
  

            if(true) {
              let template = item.template;
      
                if(template === 1 || template === 3 || template === 4 || template === 5 || template === 6 || template === 16 || template === 11){
                  if (item.answer) {
                    answerCount++;
                  }
                }
                else if(template === 13){

       
                  let isAllAnswered = 0;
                    if(item && item.SubQuestionList && item.SubQuestionList.length>0){
  
                      item.SubQuestionList.forEach((subQues)=>{
                        let getIndex2 = AnswerListFinal.findIndex(prev=>prev.questionId === subQues.id);
  
                        if(item.isMandatory){
                            if(getIndex2!==-1){
                              if(AnswerListFinal && AnswerListFinal[getIndex2] && AnswerListFinal[getIndex2].multiAnswer && AnswerListFinal[getIndex2].multiAnswer.length>1){
                                isAllAnswered ++;
                              }
                            }
                        }
                        else{
                            if(getIndex2!==-1){
                              if(AnswerListFinal && AnswerListFinal[getIndex2] && AnswerListFinal[getIndex2].multiAnswer && AnswerListFinal[getIndex2].multiAnswer.length>0){
                                isAllAnswered ++;
                              }
                            }
                        }


  
                      });
                    }
  
  
                    if(item.SubQuestionList.length>=isAllAnswered && isAllAnswered>0 ){
                      answerCount++;
                    }

                } 
                else if(template === 2){
                  if ((item && item.multiAnswer && item.multiAnswer.length>0)) {
                    answerCount++;
                  }
                }
                else{
                  if (item.answer) {
                    answerCount++;
                  }
                }
      
            }
  
  
  
            }
  
          }
          
    
          
        }

        });
  
      }

      return answerCount
    }

    let answerCount = CompletedCount();






    function GetIndex (CurrQuesIndex){
      let indx=questionsList.findIndex(prev=>prev.id===CurrQuesIndex);
      if(indx!==-1){
        return indx
      }
      else{
        return -1
      }
    }


    let {  surveyLanguageName, handleLanguage, langList } = this.props;



    console.log("answersList---",answersList)



    // let themeObj = {
    //   "bgColor":(bgType===1 || afterSubmitData.bgType===1)? (bgColor) ? bgColor : (afterSubmitData.bgColor)?afterSubmitData.bgColor: "#fff"    :"#fff",
    //   "bgImage":(bgType===2 || afterSubmitData.bgType===2)? (bgImage) ? bgImage : (afterSubmitData.bgImage)?afterSubmitData.bgImage: null   :null,
    //   "textColor":(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : (afterSubmitData && afterSubmitData.textColor)?afterSubmitData.textColor:"#757575",
      
    //   "borderColor":(surveyScreenData && surveyScreenData.borderColor) ? surveyScreenData.borderColor : (afterSubmitData && afterSubmitData.borderColor)?afterSubmitData.borderColor:"#757575",

    //   "buttonBgColor":(surveyScreenData && surveyScreenData.buttonBgColor) ? surveyScreenData.buttonBgColor : (afterSubmitData.buttonBgColor)?afterSubmitData.buttonColor1: "#757575",
    //   "buttonTextColor":(surveyScreenData && surveyScreenData.buttonTextColor) ? surveyScreenData.buttonTextColor : (afterSubmitData.buttonTextColor)?afterSubmitData.buttonColor2: "#757575",

    //   "bottomButtonBgColor":(surveyScreenData && surveyScreenData.buttonColor1) ? surveyScreenData.buttonColor1 : (afterSubmitData.buttonColor1)?afterSubmitData.buttonColor1: "#757575",
    //   "bottomButtonBgColor":(surveyScreenData && surveyScreenData.buttonColor2) ? surveyScreenData.buttonColor2 : (afterSubmitData.buttonColor2)?afterSubmitData.buttonColor2: "#757575",
    
    //   "optionTextColor":(surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : (afterSubmitData.OptionColor2)?afterSubmitData.OptionColor2: "#757575",
    //   "optionBgColor":(surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1 : (afterSubmitData.OptionColor1)?afterSubmitData.OptionColor1: "#757575",
    //   "optionBorderColor":(surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1 : (afterSubmitData.OptionColor1)?afterSubmitData.OptionColor1: "#757575",

    //   "optionTextActiveColor":(surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : (afterSubmitData.OptionColor2)?afterSubmitData.OptionColor2: "#757575",
    //   "optionBgActiveColor":(surveyScreenData && surveyScreenData.OptionColor3) ? surveyScreenData.OptionColor3 : (afterSubmitData.OptionColor3)?afterSubmitData.OptionColor3: "#757575",
    //   "optionBorderActiveColor":(surveyScreenData && surveyScreenData.OptionColor3) ? surveyScreenData.OptionColor3 : (afterSubmitData.OptionColor3)?afterSubmitData.OptionColor3: "#757575"

    // }

    let themeObj = {
      "bgColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.bgColor?getSurveyDesignByCodeData.bgColor:"#ffffff",
      "bgImage":(getSurveyDesignByCodeData && getSurveyDesignByCodeData.bgType && getSurveyDesignByCodeData.bgType===2)? (getSurveyDesignByCodeData && getSurveyDesignByCodeData.bgImage) ? getSurveyDesignByCodeData.bgImage:null:null,
      "textColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.textColor?getSurveyDesignByCodeData.textColor:"#757575",

      "borderColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.borderColor?getSurveyDesignByCodeData.borderColor:"#757575",

      "buttonBgColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.buttonBgColor?getSurveyDesignByCodeData.buttonBgColor:"#757575",
      "buttonTextColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.buttonTextColor?getSurveyDesignByCodeData.buttonTextColor:"#757575",

      "bottomButtonTextColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.bottomButtonTextColor?getSurveyDesignByCodeData.bottomButtonTextColor:"#757575",
      "bottomButtonBgColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.bottomButtonBgColor?getSurveyDesignByCodeData.bottomButtonBgColor:"#757575",

      "optionTextColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.optionTextColor?getSurveyDesignByCodeData.optionTextColor:"#757575",
      "optionBgColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.optionBgColor?getSurveyDesignByCodeData.optionBgColor:"#757575",
      "optionBorderColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.optionBorderColor?getSurveyDesignByCodeData.optionBorderColor:"#757575",

      "optionTextActiveColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.optionTextActiveColor?getSurveyDesignByCodeData.optionTextActiveColor:"#757575",
      "optionBgActiveColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.optionBgActiveColor?getSurveyDesignByCodeData.optionBgActiveColor:"#757575",
      "optionBorderActiveColor":getSurveyDesignByCodeData && getSurveyDesignByCodeData.optionBorderActiveColor?getSurveyDesignByCodeData.optionBorderActiveColor:"#757575"

    }

    console.log("getSurveyDesignByCodeData---12--->",getSurveyDesignByCodeData)

    return (
      <>
      <div className='bg-fixed'  style={{
        backgroundColor:themeObj["bgColor"],
        backgroundImage:themeObj["bgImage"],
        minHeight: '800px',
        // backgroundRepeat: 'cover',
        backgroundSize: 'auto',
        overflowX: 'hidden',
        overflowY: 'hidden',
        backgroundPosition: 'center top'
      }}>
      <LogoHeaderV9
        surveyScreenData={getSurveyTemplateByCodeData}
        template={'v2'}
        surveyLanguageName = {surveyLanguageName}
        handleLanguage = {handleLanguage} 
        langList = {langList}
        questionsList = {questionsList}
        answerCount = {answerCount}
        CurrQuesIndex = {CurrQuesIndex}
      />

      {surveyStatus !== 2  && surveyStatus !== 3 ?
      <>
       {(this.state.showWelcomeScreen && questionsList && questionsList.length>0)   ?
       <>
        <div>
          <div className="overflow-y-auto custom-scrollar" style={{
            overflowY:isMobile?'auto':'hidden',
            height:'calc(100vh - 6rem)'
            }}>

            <section className="mt-12 lg:w-4/6 md:w-5/6 mx-auto lg:px-0 md:px-6 px-4 flex h-full text-center items-start " style={{height: 'calc(100vh - 4rem)'}}>
              <div className="py-12">
                <div >
                  <h1 
                  style={{color:themeObj["textColor"]}}
                  className="md:text-3xl  text-2xl text-base font-semibold text-gray-500  ">
                  {(surveyLanguageCode!=='')?
                    (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].name)?surveyScreenData.transl[surveyLanguageCode].name:surveytitle
                  :surveytitle
                  }
                  </h1>
                  <div className="py-6  lg:text-base text-sm font-normal  mb-4 gap-3 mx-auto lg:w-11/12">
                    <div className="text-gray-500 text-center ">
                    <div className="cursor-default text-left mx-4" 

                      style={{color:themeObj["textColor"]}} 

                      dangerouslySetInnerHTML={{ __html: 
                        (surveyLanguageCode!=='')?
                        (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].welcomeText)?
                        surveyScreenData.transl[surveyLanguageCode].welcomeText:welcomeTextDislay
                        :welcomeTextDislay
                      } } />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          
        
          
          <div className={isMobile?
            "fixed bottom-0 justify-center items-center right-0  md:right-4 md:w-auto w-full bg-white bg-opacity-10 md:bg-opacity-0"
            :"fixed bottom-0  left-0 w-full bg-opacity-50 mb-2" }
          >
            <div className="flex justify-center mt-4 " onClick={() => this.goToInstructionPage()} >
              <span 
               style={{
                background:themeObj["buttonColor1"],
                color:themeObj["buttonColor2"],
              }}
              className="shadow-xl p-2 px-8 bg-white rounded text-lg text-gray-600 cursor-pointer hover:bg-gray-100 font-medium
              transform transition duration-500 hover:scale-110 uppercase">{SurveyAttributes("StartButtonText")?SurveyAttributes("StartButtonText"):"Start Survey"}</span></div>
            <p style={{color:themeObj["textColor"]}} className="text-sm pt-4  text-center ">© Powered by HappyPlus</p>
          </div>


          

        </div>

      </>
      :null}

      {this.state.instructionPage ?
      <>






  <div>
          <div className="overflow-y-auto custom-scrollar" style={{
            // height: '80%',
            overflowY:isMobile?'auto':'hidden',
            height:'calc(100vh - 6rem)'
            }}>

            <section className="mt-12 lg:w-4/6 md:w-5/6 mx-auto lg:px-0 md:px-6 px-4 flex h-full text-center items-start " style={{height: 'calc(100vh - 4rem)'}}>
              {/* quz 1 */}
              <div className="py-12">
                <div className>
                  <h1 
                  style={{color:themeObj["textColor"]}}
                  className="md:text-3xl  text-2xl text-base font-semibold text-gray-500  ">
                  {LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].InstructionLabelText?LabelObj[surveyLanguageCode].InstructionLabelText:SurveyAttributes("instructionLabel")?SurveyAttributes("instructionLabel"):"I n s t r u c t i o n s"}
                  </h1>
                  <div className="py-6  lg:text-base text-sm font-normal  mb-4 gap-3 mx-auto lg:w-11/12">
                    <p className="text-gray-500 text-center ">
                    <div className="cursor-default text-left mx-4" 
                      style={{color:themeObj["textColor"]}} 
                      dangerouslySetInnerHTML={{ __html: 
                        (surveyLanguageCode!=='')?
                        (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].instructionText)?surveyScreenData.transl[surveyLanguageCode].instructionText:instructionTextDislay
                        :instructionTextDislay
                      } } />
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          {/* start btn */}
          
        
          
          <div className={isMobile?
            "fixed bottom-0 justify-center items-center right-0  md:right-4 md:w-auto w-full bg-white bg-opacity-10 md:bg-opacity-0"
            :"fixed bottom-0  left-0 w-full bg-opacity-50 mb-2" }
          >
            <div className="flex justify-center mt-4 " onClick={() => this.goToQuestionPage()} >
              <span 
               style={{
                background:themeObj["buttonColor1"],
                color:themeObj["buttonColor2"],
              }}
              className="shadow-xl p-2 px-8 bg-white rounded text-lg text-gray-600 cursor-pointer hover:bg-gray-100 font-medium
              transform transition duration-500 hover:scale-110 uppercase">{
                SurveyAttributes("ContinueButtonText")?SurveyAttributes("ContinueButtonText"):"Continue"
              }</span></div>
            <p style={{color:themeObj["textColor"]}} className="text-sm pt-4 text-white  text-center ">© Powered by HappyPlus</p>
          </div>


          

        </div>

      </>
      :null}

      {this.state.showQuestionScreen && !this.state.submitSucces? 
        <div  >

              <section className="xl:w-3/6 lg:w-4/6 md:py-2 py-4 mx-auto lg:px-0 md:px-6 px-2 overflow-y-auto overflow-x-hidden" 
              style={{
              overflowY:isMobile?'auto':'hidden', 
              height:isMobile?'calc(100vh - 4rem)':'1000px'
              }}
              
              
              >
              <div className="flex justify-center pb-4 mt-24">
              </div>
              <div className=""> 
              <TransitionGroup>
   
              {questionsList && questionsList.length > 0 ?
                questionsList.map((question, questionindex) =>
                  (   (question.id ===  CurrQuesIndex
                    
                    
                    )  ) ?
                  <CSSTransition
                    timeout={350}
                    classNames={(this.state.changeType)}
                    key={question.id}
                  >
                    <>

                    {true?
                    <div > 
                    


  {/* -----------------------------Question Name Start------------------------------------------------------ */}
          

            
                <div className='mx-3'>
                { question.templateId !== 14?
                  
                  
                  question.templateId===10?
                  <>
                    <h1 
                    style={{color:themeObj["textColor"]}}
                    className="md:text-xl text-base font-normal text-gray-500 ">{(questionindex+1).toString()+'. '}{(surveyLanguageCode!=='')?
                                (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].name)?
                                    question.transl[surveyLanguageCode].name:question.name
                              :question.name}</h1>

                    </>
                    :
                    <>

                    
                    {question.parentId?
                    <>

                      {question && question["QuesMain"]?
                      <>
                        <QuestionHeader
                        surveyLanguageCode={surveyLanguageCode}
                        question={question["QuesMain"]}
                        />
                      </>
                      :null}


                        <h1 
                        style={{color:themeObj["textColor"]}}
                        className="md:text-xl text-base font-normal text-gray-500 ">{(surveyLanguageCode!=='')?
                                    (question && question["QuesMain"] && question["QuesMain"].transl && question["QuesMain"].transl[surveyLanguageCode] && question["QuesMain"].transl[surveyLanguageCode].name)?
                                        question["QuesMain"].transl[surveyLanguageCode].name:    question && ["QuesMain"] && question["QuesMain"].name?question["QuesMain"].name:""
                                  :  question && ["QuesMain"] && question["QuesMain"].name?question["QuesMain"].name:""}</h1>
                    

                        <h1 
                        style={{color:themeObj["textColor"]}}
                        className="md:text-xl text-base font-normal text-gray-500  mt-4">{(questionindex+1).toString()+'. '}{(surveyLanguageCode!=='')?
                                    (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].name)?
                                        question.transl[surveyLanguageCode].name:question.name
                                  :question.name}</h1>
                    
                    </>
                    :
                    <>
                    <div className="quz ">
                      <QuestionHeader
                        surveyLanguageCode={surveyLanguageCode}
                        question={question}
                        QuesNo={(questionindex+1).toString()+'. '}
                      />
                      </div>

                      <h1 
                      style={{color:themeObj["textColor"]}}
                      className="md:text-xl text-base font-normal text-gray-500">{(questionindex+1).toString()+'. '}{(surveyLanguageCode!=='')?
                                    (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].name)?
                                        question.transl[surveyLanguageCode].name:question.name
                                  :question.name}</h1>

                    </>
                    }



                    </>
                    
                  :null}
                  </div>





          {/* -----------------------------Question Name End------------------------------------------------------ */}





   {/* Single Choice */}
   {question.templateId === 1?
          <>
          <div className="">
            <SingleChoice 
              question={question}
              clicked={clicked}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              handleRadio={this.handleRadio}
              surveyScreenData={surveyScreenData}
              isMobile={isMobile}
              themeObj={themeObj}
            />
          </div>
          </>
         :null}


        {/* Multiple Choice */}
        {question.templateId === 2?
          <>
            <MultipleChoice 
              question={question}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              handleCheckInput={this.handleCheckInput}
              surveyScreenData={surveyScreenData}
              isMobile={isMobile}
              themeObj={themeObj}
            />
          </>
         :null}



          {/* Multitext Box */}
          {question.templateId === 3?
          <>
            <TextBox
              question={question}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              SurveyAttributes={SurveyAttributes}
              ansTextBoxChange1={this.ansTextBoxChange1}
              surveyScreenData={surveyScreenData}
              themeObj={themeObj}
            />
          </>
          :null}



          {/* Multitext Box */}
          {question.templateId === 4?
          <>
            <MultiLineText
              question={question}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              SurveyAttributes={SurveyAttributes}
              ansTextBoxChange1={this.ansTextBoxChange1}
              surveyScreenData={surveyScreenData}
              themeObj={themeObj}
            />
          </>
          :null}


          {/* Rating Scale */}
          {question.templateId === 5?
          <>
          <RatingScale
              question={question}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              handleRadio={this.handleRadio}
              surveyScreenData={surveyScreenData}
              themeObj={themeObj}
          /> 
          </>
          :null}


          {/* NPS Scale 1-10*/}
          {question.templateId === 6?
          <>
          <NPS
              question={question}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              ansNPSInput={this.ansNPSInput}
              surveyScreenData={surveyScreenData}
              themeObj={themeObj}
              SurveyAttributes={SurveyAttributes}
              isMobile={isMobile}
          /> 
          </>
          :null}


          {/* NPS Scale 0-10 */}
          {question.templateId === 16?
          <>
          <NPSV2
              question={question}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              ansNPSInput={this.ansNPSInput}
              surveyScreenData={surveyScreenData}
              themeObj={themeObj}
              SurveyAttributes={SurveyAttributes}
              isMobile={isMobile}
          /> 
          </>
          :null}

          {/* Email */}
          {question.templateId === 7?
          <>
            <Email
                question={question}
                answersList={answersList}
                surveyLanguageCode={surveyLanguageCode}
                ansTextBoxChange1={this.ansTextBoxChange1}
                surveyScreenData={surveyScreenData}
                themeObj={themeObj}
            />
          </>
          :null}




          {/* Number */}
          {question.templateId === 8?
          <>
            <Number
                question={question}
                answersList={answersList}
                surveyLanguageCode={surveyLanguageCode}
                ansTextBoxChange1={this.ansTextBoxChange1}
                surveyScreenData={surveyScreenData}
                themeObj={themeObj}
            />
          </>
          :null}




          {/* Dropdown */}
          {question.templateId === 9?
                <>
                  <Dropdown
                    question={question}
                    clicked={clicked}
                    answersList={answersList}
                    handleRadio={this.handleRadio}
                    handleDropdownSelect={this.handleDropdownSelect}
                    surveyScreenData={surveyScreenData}
                    themeObj={themeObj}
                  />
                </>
            :null}



          {/* Dropdown */}
          {question.templateId === 15?
                <>
                  <Location
                    question={question}
                    clicked={clicked}
                    answersList={answersList}
                    handleRadio={this.handleRadio}
                    handleDropdownSelect={this.handleDropdownSelect}
                    surveyScreenData={surveyScreenData}
                    storeStateCode={storeStateCode}
                    storeCityCode={storeCityCode}
                    surveyLanguageCode={surveyLanguageCode}
                    themeObj={themeObj}

                  />
                </>
            :null}



          {/* Yes/No */}
          {question.templateId === 11?
          <>
            <YesNo 
              question={question}
              clicked={clicked}
              answersList={answersList}
              surveyLanguageCode={surveyLanguageCode}
              handleRadio={this.handleRadio}
              surveyScreenData={surveyScreenData}
              isMobile={isMobile}
              themeObj={themeObj}
            />
          </>
         :null}


          {/* Date */}
          {question.templateId === 12?
          <>
             <Date
                question={question}
                answersList={answersList}
                surveyLanguageCode={surveyLanguageCode}
                ansTextBoxChange1={this.ansTextBoxChange1}
                surveyScreenData={surveyScreenData}
                themeObj={themeObj}
            />
          </>
          :null}


          {/* Matrix  */}
          {question.templateId === 13?
            <> 
              <div className="w-full mb-20 pt-4">
              
              <div className="overflow-x-auto  whitespace-nowrap w-full   px-6  " >
                
                
              {isMobile?
              <>
              {/* MOBILE VIEW */}
                {question && question.SubQuestionList && question.SubQuestionList.length>0?
                question.SubQuestionList.map((SubQues,index)=>
                    <>
                    <div className="pb-6" key={index}
                    
                    > 
                      <div 
                      style={{color:themeObj["textColor"]}}
                      className="whitespace-pre-line py-2">{TranslateQuestion(surveyLanguageCode,SubQues)}</div>

                      <table className="text-center border border-gray-100 w-full mx-auto" 
                      style={{color:themeObj["textColor"]}}>
                        <thead >
                          

                          {/* {FormatMatriXOptionHeading(question, false) && FormatMatriXOptionHeading(question, false).length>0?
                          <tr>
                            {FormatMatriXOptionHeading(question, false).map((heading, optionindex) =>
                            <td 
                            style={{
                              color:themeObj["textColor"],
                              borderColor:themeObj["textColor"]
                            }}
                            key={optionindex} colSpan={heading.span} className="px-2 text-sm font-semibold text-center ">
                              {TranslationOptionMatrix(question,heading.name,surveyLanguageCode)}  
                            </td>
                            )}
                            </tr>
                            :null} */}

                          
                          <tr>
                          {FormatMatriXOptionHeading(question, true) && FormatMatriXOptionHeading(question, true).length>0?
                            FormatMatriXOptionHeading(question, true).map((option, optionindex) =>
                            <td 
                            style={{
                              color:themeObj["textColor"],
                              borderColor:themeObj["textColor"]
                            }}
                            className="text-center font-semibold   border border-gray-600">{(surveyLanguageCode!=='')?
                            (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id])?
                                question.transl[surveyLanguageCode].optionsList[option.id]:option.name
                            
                            :option.name
                            }</td>
                            ):null}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                          {FormatMatriXOptionHeading(question, true) && FormatMatriXOptionHeading(question, true).length?
                            FormatMatriXOptionHeading(question, true).map((option, optionindex)=>
                            <td 
                            style={{
                              color:themeObj["textColor"],
                              borderColor:themeObj["textColor"]
                            }}
                            className="text-center  border border-gray-400 p-1">
                                { showRadioMatrix(SubQues,option)?
                                <span style={{color:(surveyScreenData && surveyScreenData.OptionColor3) ? surveyScreenData.OptionColor3 : "#757575"}}
                                 onClick={() => this.handleMatrixRadio(question,SubQues, option)} className="material-icons">task_alt</span>
                                :
                                <span style={{color:themeObj["textColor"]}}
                                onClick={() => this.handleMatrixRadio(question,SubQues, option)} className="material-icons">radio_button_unchecked</span>
                                }
                            </td>
                            ):null}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    </>
                  ):null}

                </>




                :




                <>
                {question && question.SubQuestionList && question.SubQuestionList.length>0?
                  <table 
                  style={{color:themeObj["textColor"]}}
                  className="min-w-full relative  " >
                    <thead className="">

                      <tr>
                        <td 
                        style={{color:themeObj["textColor"]}}
                        className="border border-gray-300  p-1 sticky top-0" rowSpan={2}></td>
                        
                        {FormatMatriXOptionHeading(question, false) && FormatMatriXOptionHeading(question, false).length?
                          FormatMatriXOptionHeading(question, false).map((heading, optionindex) =>
                          <td key={optionindex} colSpan={heading.span} className="sticky top-0 border border-gray-300 text-center p-2 font-semibold" 
                          style={{color:themeObj["textColor"]}}> 
                            {TranslationOptionMatrix(question,heading.name,surveyLanguageCode)}
                          </td>
                          ):null}

                      </tr>

                      <tr>
                        {/* <td className="w-40 text-left py-3 px-4 text-sm border border-gray-300 "> </td> */}

                        {FormatMatriXOptionHeading(question, true) && FormatMatriXOptionHeading(question, true).length?
                        FormatMatriXOptionHeading(question, true).map((option, optionindex) =>
                        <td  key={optionindex}
                        style={{color:themeObj["textColor"]}}
                        className="sticky top-4 text-left py-1 px-4 text-sm text-center border border-gray-300 font-semibold">{
                          (surveyLanguageCode!=='')?
                            (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id])?
                                question.transl[surveyLanguageCode].optionsList[option.id]:option.name
                            
                            :option.name
                          }</td>
                        ):null}
                      </tr>


                      
                    </thead>
                    <tbody className="">
                    {question.SubQuestionList.map((SubQues,index)=>
                      <tr key={index}>
                        <td className="w-82 text-left py-1 px-4 text-sm border border-gray-300 whitespace-pre-line"
                       style={{color:themeObj["textColor"]}}
                        > {TranslateQuestion(surveyLanguageCode,SubQues)} </td>
                        {FormatMatriXOptionHeading(question, true) && FormatMatriXOptionHeading(question, true).length?
                        FormatMatriXOptionHeading(question, true).map((option, optionindex)=>
                        <td key={optionindex} className="text-center py-1 px-4 border border-gray-300">

                          { showRadioMatrix(SubQues,option)?
                          <span style={{
                            
                            color:(surveyScreenData && surveyScreenData.OptionColor3) ? surveyScreenData.OptionColor3:'black'
                        
                          }} onClick={() => this.handleMatrixRadio(question,SubQues, option)} className="material-icons">task_alt</span>
                          :
                          <span style={{color:themeObj["textColor"]}} 
                          onClick={() => this.handleMatrixRadio(question,SubQues, option)} className="material-icons">radio_button_unchecked</span>
                          }

                        </td>
                        ):null}
                      </tr>
                    )}
                      
                    </tbody>
                  </table>
                  :null}

                </>

                }






                
                </div>



              </div>

            </>
            :null}













                    </div>

                  
                  
                  :null}





              <div className="px-2 pt-3 justify-center items-center my-2"> 
              {this.state.unattemptList && this.state.showRedFlag?
               this.state.unattemptList && this.state.unattemptList.length>0?
                <p className="md:px-6 px-4 md:text-md text-gray-100 font-light">
                  <span style={{cursor:'default', color:themeObj["textColor"]}} 
                  className="font-normal">
                    {'Please attempt mandatory question no. '}</span>
                  {this.state.unattemptList.map((elem,index)=>
                    <span key={index} onClick={()=>this.onMandatoryAttempt(elem)} 
                      style={{cursor:'pointer',fontWeight:'bold', color:themeObj["textColor"]}}>
                      {(index+1 === this.state.unattemptList.length)?
                      <span style={{textDecoration:'underline'}}>{' ' + (GetIndex(elem)+1)}</span>
                      :
                    <span style={{textDecoration:'underline'}}>{(GetIndex(elem)+1) + ' , '}</span>
                      }
                      </span>
                    )}
                  
                </p>
                :null:null}
              </div>

                {this.state.ShowSubmitButton ?
                  <div className="pt-3 pb-40 flex justify-center"> <button 
                  style={{
                    background:themeObj["buttonColor1"],
                    color:themeObj["buttonColor2"],
                  }} 
                  onClick={() => !submitBlock?this.saveAnswers(surveyScreenData):{}}
                  // onClick={() => this.saveAnswers(surveyScreenData)} 
                  className="shadow-xl p-2 px-8 bg-white rounded text-lg text-gray-600 cursor-pointer hover:bg-gray-100 font-medium
                  transform transition duration-500 hover:scale-110 uppercase">
                    {/* {LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].SubmitButton?LabelObj[surveyLanguageCode].SubmitButton:"Submit"} */}
                    {SurveyAttributes("SubmitButtonText")?SurveyAttributes("SubmitButtonText"):"Submit"}
                    </button></div>

                :null}


                </>

                    </CSSTransition>
                          : null) : null}
                  </TransitionGroup>





                    <div className="fixed bottom-0 right-0  md:right-4 md:w-auto w-full pt-3 bg-white bg-opacity-10 md:bg-opacity-0">
                        
                        <div className=" flex md:justify-end  justify-between rounded-lg mx-auto items-center text-white md:px-0 px-4 mb-4 mx-auto md:mr-24">
                 
                          <div className="text-gray-600 flex divide-x shadow-lg ml-1">
                            <button style={{
                                background:themeObj["bottomButtonBgColor"],
                                color:themeObj["bottomButtonTextColor"]
                              }} onClick={() => this.prevQues()} className="material-icons p-2  cursor-pointer focus:bg-gray-100 rounded-l ">chevron_left</button>
                            <button style={{
                              background:themeObj["bottomButtonBgColor"],
                              color:themeObj["bottomButtonTextColor"]
                            }} onClick={() => this.nextQues()} className="material-icons p-2 cursor-pointer focus:bg-gray-100 rounded-r">chevron_right</button>
                          </div> 
                     
                          <div className="shadow-lg flex bg-white rounded text-gray-600 items-center text-xs px-2 py-1 ml-2 mr-1">© Powered by <img src="img/newlogo.png" className="p-1 h-8 ml-1" /></div>
                        
                        </div>
                      </div>


                  </div>
                </section>
        




      </div>
      
      :null}

      {this.state.showThankyouScreen? 



      <section className="lg:w-4/6 md:w-5/6 mx-auto lg:px-0 md:px-6 px-4 flex h-full text-center items-center  relative" style={{height: 'calc(100vh - 4rem)'}}>
        {/* quz 1 */}
        <div className="py-12 w-full">
          <div className="w-full space-y-4">
            <div className="flex justify-center">
              <div className="p-4 bg-white bg-opacity-10 rounded-full">
                <div className="p-6 bg-white rounded-full "><img src="img/notFound.png" className="w-20" /></div></div>
            </div>
            <h1 className="md:text-4xl text-2xl text-base font-semibold   pt-2 ">
              <div 
                className="text-center font-bold text-xl mt-6"
                style={{textAlign:'center', 
                color:themeObj["textColor"]}} 
                dangerouslySetInnerHTML={{ __html: 
                  (surveyLanguageCode!=='')?(afterSubmitData && afterSubmitData.transl && afterSubmitData.transl[surveyLanguageCode] && afterSubmitData.transl[surveyLanguageCode].thankyouText)?
                  "<h1>"+afterSubmitData.transl[surveyLanguageCode].thankyouText+"</h1>":(afterSubmitData && afterSubmitData.thankyouText?"<h1>"+afterSubmitData.thankyouText+"</h1>":"<h1>Thank You for Participating !</h1>"):(afterSubmitData && afterSubmitData.thankyouText?afterSubmitData.thankyouText:"<h1>Thank You for Participating !</h1>")
              }} />
            </h1>
          </div>
        </div>
      </section>

   


      
      :null} 













      </>
      :null}



                  {((surveyStatus === 2 && !(questionsList && questionsList.length>0)) || this.state.alreadySubmitted)? //already done
                    
                    



                    <div className="py-12 w-full">
                      <div className="w-full space-y-4">
                        <div className="flex justify-center">
                          <div className="p-4 bg-white bg-opacity-10 rounded-full"><div className="p-6 bg-white rounded-full "><img src="img/submitted.png" className="w-20" /></div></div>
                        </div>
                        <h1 className="md:text-4xl text-xl text-base font-semibold text-white pt-2 ">
                          <div 
                                style={{textAlign:'center', color:themeObj["textColor"]}} 
                                dangerouslySetInnerHTML={{ __html:
                                  
                                  // LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].SurveyAlreadyDoneText?
                                  // '<h1>'+LabelObj[surveyLanguageCode].SurveyAlreadyDoneText+'</h1>':"<h1>Survey Is Already Submitted !</h1>"
                                  SurveyAttributes("AlreadyText")?'<h1>'+SurveyAttributes("AlreadyText")+'</h1>':"<h1>Survey Is Already Submitted !</h1>"

                              }}/> 
                        </h1>
  
                      </div>
                    </div>






                  :null}

                  {/* survey expired page ----------------------------------------------------------------------------------------------- */}

                  {surveyStatus === 3 && !(questionsList && questionsList.length>0)? //expired


      <div className="py-12 w-full">
        <div className="w-full space-y-4">
          <div className="flex justify-center">
            <div className="p-4 bg-white bg-opacity-10 rounded-full"><div className="p-6 bg-white rounded-full "><img src="img/expired.png" className="w-20" /></div></div>
          </div>
          <h1 className="md:text-4xl text-xl text-base font-semibold text-white pt-2 ">
            <div
              className="text-center font-bold text-2xl mt-6"
              style={{textAlign:'center', color:themeObj["textColor"]}} 
              dangerouslySetInnerHTML={{ __html:
                
                // LabelObj && LabelObj[surveyLanguageCode] && LabelObj[surveyLanguageCode].SurveyExpiredText? '<h1>' + LabelObj[surveyLanguageCode].SurveyExpiredText+'</h1>':"<h1>This Survey is <br>Expired!</h1>"

                SurveyAttributes("ExpiryText")?'<h1>'+SurveyAttributes("ExpiryText")+'</h1>':"<h1>This Survey is <br>Expired!</h1>"
              }}/>
          </h1>
        </div>
      </div>
              :null}




</div>
      </>
    );
  }
}
QuestionPublish.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users } = state;
  return {
    loggingIn,
    questions,
    users

  };
}

export default connect(mapStateToProps)(QuestionPublish);
